module.exports = __webpack_public_path__ + "static/media/BW201910_03.b2b9b09c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BW201910_03.jpg
// module id = 370
// module chunks = 0